// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"451":"8ebe7f07","711":"ef8b46b0","771":"5ee6b5aa"}[chunkId] + ".chunk.css";
};